import { render, staticRenderFns } from "./AddCustomerDetails.vue?vue&type=template&id=2d2dc3b3&scoped=true&"
import script from "./AddCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./AddCustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2dc3b3",
  null
  
)

export default component.exports